import { render, staticRenderFns } from "./ServiceMarketing.vue?vue&type=template&id=5423f271&scoped=true&"
import script from "./ServiceMarketing.vue?vue&type=script&lang=js&"
export * from "./ServiceMarketing.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMarketing.vue?vue&type=style&index=0&id=5423f271&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423f271",
  null
  
)

export default component.exports